const getPublicDisplayNumber = (publicNumber, id) => {
	const normalized = publicNumber != null ? String(publicNumber).trim() : "";
	if (normalized) return normalized;
	if (id != null && String(id).trim() !== "") return String(id);
	return "";
};

export const getInvoiceDisplayNumber = ({ invoice_number, id } = {}) =>
	getPublicDisplayNumber(invoice_number, id);

export const getOnlineSaleDisplayNumber = ({ invoice_number } = {}) => {
	const normalized = invoice_number != null ? String(invoice_number).trim() : "";
	return normalized;
};

export const getEstimateDisplayNumber = ({ estimate_number, id } = {}) =>
	getPublicDisplayNumber(estimate_number, id);

export const getWorkOrderDisplayNumber = ({ work_order_number, id } = {}) =>
	getPublicDisplayNumber(work_order_number, id);

export const getReceiptLookupCode = ({ receipt_number, receipt_nro, id } = {}) => {
	const normalized = receipt_number != null ? String(receipt_number).trim() : "";
	if (normalized) return normalized;
	const legacy = receipt_nro != null ? String(receipt_nro).trim() : "";
	if (legacy) return legacy;
	if (id != null && String(id).trim() !== "") return String(id);
	return "";
};

export const getReceiptDisplayNumber = ({ receipt_number, receipt_nro, id } = {}) => {
	const normalized = receipt_number != null ? String(receipt_number).trim() : "";
	if (normalized) return normalized;
	const legacy = receipt_nro != null ? String(receipt_nro).trim() : "";
	if (legacy) return legacy;
	if (id != null && String(id).trim() !== "") return String(id);
	return "";
};

export const getSalesRowDisplayNumber = (row = {}) => {
	const type = String(row.type || "").toLowerCase().replace(/\s+/g, "");
	if (type === "estimate") {
		return getEstimateDisplayNumber({ estimate_number: row.estimate_number, id: row.id });
	}
	if (type === "workorder") {
		return getWorkOrderDisplayNumber({ work_order_number: row.work_order_number, id: row.id });
	}
	if (type === "invoice") {
		return getInvoiceDisplayNumber({ invoice_number: row.invoice_number, id: row.id });
	}
	if (type === "onlinesales") {
		return getOnlineSaleDisplayNumber({ invoice_number: row.invoice_number });
	}
	if (type === "receipt") {
		return getReceiptDisplayNumber({ receipt_number: row.receipt_number, receipt_nro: row.receipt_nro, id: row.id });
	}
	if (row.id != null && String(row.id).trim() !== "") return String(row.id);
	return "";
};
